import { useSelector } from 'react-redux';
import { RootState } from '../store';

export function useAuth() {
    const { user } = useSelector((state: RootState) => state.auth);

    return {
        isAdmin: user?.utype === 'ADMIN',
        isUser: user?.utype === 'USER',
        user
    };
}

export function canManageInventory(utype: string | undefined): boolean {
    return utype === 'ADMIN';
}

export function canAccessRoute(utype: string | undefined, route: string): boolean {
    const adminOnlyRoutes = [
        '/stores',
        '/users',
        '/settings',
        '/inventory/manage'
    ];

    if (adminOnlyRoutes.includes(route)) {
        return utype === 'ADMIN';
    }

    return true;
} 